import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Encabezado con logo del comercio y pie de las páginas públicas MIT.
 * `fullWidth` deja el contenido a todo el ancho (layout de dos columnas del checkout).
 */
@Component({
  selector: 'app-public-mit-shell',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  template: `
    <div class="min-h-screen flex flex-col bg-slate-100">
      <header class="shrink-0 border-b border-slate-200/80 bg-white/70 backdrop-blur-md sticky top-0 z-30">
        <div class="mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16" [class]="fullWidth() ? 'max-w-7xl' : 'max-w-3xl'">
          <div class="flex items-center gap-3 min-w-0">
            @if (logoUrl()) {
              <img [src]="logoUrl()" alt="Logo del comercio" class="h-9 w-auto max-w-[180px] object-contain" />
            } @else {
              <img src="assets/images/pento-icon.png" alt="Pento" class="h-7 w-auto" />
            }
            @if (merchantName()) {
              <span class="text-sm font-semibold text-slate-800 truncate">{{ merchantName() }}</span>
            }
          </div>
          <div class="flex items-center gap-2 text-slate-400">
            <i class="pi pi-lock text-sm"></i>
            <span class="text-xs font-medium hidden sm:inline">Pago seguro</span>
          </div>
        </div>
      </header>
      <main class="flex-1 flex flex-col w-full min-h-0"
        [class]="fullWidth() ? '' : 'max-w-3xl mx-auto px-4 sm:px-6 py-8 gap-5'">
        <ng-content />
      </main>
      <footer class="mt-auto shrink-0 border-t border-slate-200/80 bg-white/90">
        <div class="mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2" [class]="fullWidth() ? 'max-w-7xl' : 'max-w-3xl'">
          <div class="flex items-center gap-1.5 text-slate-400">
            <i class="pi pi-lock text-[11px]"></i>
            <span class="text-[11px]">Pago seguro con cifrado SSL · Procesado por Pento</span>
          </div>
          <p class="text-slate-300 text-[10px] m-0">&copy; 2026 Pento &mdash; Todos los derechos reservados</p>
        </div>
      </footer>
    </div>
  `
})
export class PublicMitShellComponent {
  logoUrl = input<string | null | undefined>(null);
  merchantName = input<string | null | undefined>(null);
  fullWidth = input(false);
}
